// 3835
import React from "react";
import ReactDOM from "react-dom";
import Dealer from "./models/Dealer";
import DealerDetails from "./models/DealerDetails";
import CarSelect from "./components/CarSelect";
import StepNav from "./components/StepNav";
import DayPicker from "./components/DayPicker";
import TimePicker from "./components/TimePicker";
import moment from "moment-timezone";
import { enforceTermsOnForm } from "./utils/Form";
import { Breakpoint } from "./utils/Breakpoints";
import find from "lodash/find";
import each from "lodash/each";

// The mobile retailer card hides "3. My details" behind an explicit
// "Set as my preferred retailer" confirmation (RetailersPopupMap's
// "retailerConfirmed" event); desktop has no such button and keeps
// revealing the form as soon as a dealer auto-selects.
const isMobileViewport = (): boolean => {
  const breakpoint = Breakpoint();
  return breakpoint === "xs" || breakpoint === "xxs";
};

const TestDrive = (): void => {
  if (!document.querySelector(".testDrive")) {
    return;
  }

  const SN = new StepNav();
  const CS = new CarSelect();
  let dealer: Dealer = null;
  let tradingDetails: DealerDetails;

  const mobileDestDriveField: any = document.getElementById(
    "requestedMobileTestDrive"
  );

  const applyIntroCopyOnSelectionChange = (modelName: string) => {
    var introDiv = document.getElementById("introText");
    var introText = window["introText"];
    var introTextOverrides = window["introTextOverrides"];

    if (!modelName || modelName.length == 0) {
      if (introDiv) {
        introDiv.innerHTML = introText;
      }
    } else {
      if (introTextOverrides) {
        each(introTextOverrides, (item) => {
          if (item.modelPicker === modelName) {
            if (introDiv) {
              introDiv.innerHTML = item.introTextOverride;
              return false;
            }
          }
          else {
            introDiv.innerHTML = introText;
          }
        });
      }
    }
  };

  //CarSelect
  CS.onSelectionComplete = (selectedCars) => {
    const evt: CustomEvent = new CustomEvent("modelSelected");
    window.dispatchEvent(evt);

    const carItem: HTMLDivElement = selectedCars[0].carItem;
    const modelName: HTMLInputElement = document.getElementById(
      "modelName"
    ) as HTMLInputElement;
    const modelImageUrl: HTMLInputElement = document.getElementById(
      "modelImageUrl"
    ) as HTMLInputElement;
    const selectedModelName: string = CS.selectedCars[0].modelName;
    const selectedModelImage: string = carItem
      .querySelector(`.carSelect__itemImage`)
      .getAttribute("src");

    if (modelName && selectedModelName) modelName.value = selectedModelName;

    if (modelImageUrl && selectedModelImage)
      modelImageUrl.value = selectedModelImage;

    CS.scope.querySelector(
      `.carSelect__selectedCarModelName`
    ).textContent = `Subaru ${selectedModelName}`;
    CS.scope
      .querySelector(`.carSelect__selectedCarImage`)
      .setAttribute("src", selectedModelImage);

    applyIntroCopyOnSelectionChange(selectedModelName);
  };

  const getModelFromURL = () => {
    return new URLSearchParams(window.location.search).get("model") || "";
  }

  const getModelFromUserSegment = () => {
    const existingSegment = localStorage.getItem("userSegment")
      ? JSON.parse(localStorage.getItem("userSegment"))
      : null;
    if (existingSegment) {
      const modelName = existingSegment.Last_Car_Model || "";
      return modelName;
    }
    return "";
  }

  const selectedModel = getModelFromURL() || getModelFromUserSegment();

  const selectModel = (selectedModelName : string, imageSrc : string, item : Element) => {
  const modelName: HTMLInputElement = document.getElementById(
    "modelName"
  ) as HTMLInputElement;
  item.classList.add("active");
  item.classList.add("car-selected");

  const checkbox = item.querySelector(".car-checkbox__input") as HTMLInputElement;
  if (checkbox) checkbox.checked = true;

  modelName.value = selectedModelName;

  applyIntroCopyOnSelectionChange (selectedModelName);

  const mappedModelName = (() => {
    const name = selectedModelName.toLowerCase();
    if (name.includes("all-new outback")) return "Outback2026";
    if (name.includes("wilderness")) return "Wilderness2026";
    return selectedModelName;
  })();

  history.replaceState(
    null,
    null,
    document.location.pathname +
      (selectedModelName.length > 0 ? `?model=${mappedModelName}` : "")
  );
}


  Array.from(document.querySelectorAll('.car-item')).forEach(item => {

    const modelName = item.getAttribute('data-modelname');
    const imageSrc = item.getAttribute("data-image");
    const defaultModel = item.getAttribute("data-default-model");


    item.addEventListener('click', () => {

      if (item.classList.contains("car-selected")) return;

      Array.from(document.querySelectorAll('.car-item')).forEach(i => {
        i.classList.remove("car-selected");
        i.classList.remove("active");
        const cb = i.querySelector(".car-checkbox__input") as HTMLInputElement;
        if (cb) cb.checked = false;
      });

      selectModel(modelName, imageSrc, item);
      const evt: CustomEvent = new CustomEvent("modelSelected");
      window.dispatchEvent(evt);

    });

    //Set default selection: "Forester"
    if (selectedModel === "") {
      if (modelName.toLocaleLowerCase() === defaultModel.toLocaleLowerCase()) {
        selectModel(modelName, imageSrc, item);
      }
    } else {
      if (modelName.toLocaleLowerCase() === selectedModel.toLocaleLowerCase()) {
        selectModel(modelName, imageSrc, item);
      } 
    }

  });

  var changePostCode = document.getElementById("changePostCode");
  if (changePostCode) {
    changePostCode.addEventListener("click",(item) => {
      item.preventDefault();
      const evt = new CustomEvent("selectLocation", { detail: {} });
      window.dispatchEvent(evt);
    }
    );
  }

  
  //StepNav Change
  SN.beforeChange = (step: number) => {};

  SN.onChangeComplete = (step: number) => {
    switch (step) {
      case 0:
        CS.reset();
        break;

      case 1:
        renderTimePicker();
        renderDayPicker();
        showForm();
        break;
    }
    window['pushDigitalData']({
      "event": "_formNavigate",
      "form": {
          "name": SN.groupTitle,
          "stage": (SN.scope.querySelector("li.is-active span")).textContent
      },
    }, true);
  };

  //Dealer Selected
  window.addEventListener("dealerSelected", (event: any): void => {
    dealer = event.detail.dealer;

    const dealerName = document.getElementById("dealerName") as HTMLInputElement;
    const dealerId = document.getElementById("dealerId") as HTMLInputElement;
    const dealerCrmId = document.getElementById("dealerCrmId") as HTMLInputElement;
    const dealerUniqueName = document.getElementById("dealerUniqueName") as HTMLInputElement;

    dealerName.value = dealer.name;
    dealerId.value = dealer.id;
    dealerCrmId.value = dealer.crmDealerId;
    dealerUniqueName.value = dealer.uniqueName;
    // Prefer the "Vehicle Sales" department, but fall back to the first
    // available department (matching how the retailer card renders). A dealer
    // without a "Vehicle Sales" entry must not leave tradingDetails undefined:
    // getDisabledDays() derefs it while rendering the datepicker, and a throw
    // there (after the wrap is cleared) makes the datepicker disappear when a
    // second dealer is selected without reloading.
    tradingDetails =
      find(
        dealer.dealerDetails,
        (details) => details.departmentName === "Vehicle Sales"
      ) || (dealer.dealerDetails && dealer.dealerDetails[0]);

    renderTimePicker();
    renderDayPicker();

    if (isMobileViewport()) {
      document.querySelector(".testDrive__form").classList.add("fadedForm");
    } else {
      showForm();
    }
  });

  //Retailer explicitly confirmed via the mobile "Set as my preferred
  //retailer" button (desktop reveals the form directly from dealerSelected)
  window.addEventListener("retailerConfirmed", (): void => {
    showForm();
  });

  //Date selected
  window.addEventListener("dayPickerChanged", (event: any): void => {
    const now = moment();
    const date = moment(new Date(event.detail.date));
    const day = date.format("dddd");

    let timeOpen;
    let timeClosed;
    let earliestAvailableTime;

    if (!tradingDetails) {
      renderTimePicker();
      return;
    }

    switch (day) {
      case "Monday":
      case "Tuesday":
      case "Wednesday":
      case "Thursday":
      case "Friday":
        timeOpen = moment(tradingDetails.monFriOpen, "h:m a");
        timeClosed = moment(tradingDetails.monFriClose, "h:m a");
        break;
      case "Saturday":
        timeOpen = moment(tradingDetails.satOpen, "h:m a");
        timeClosed = moment(tradingDetails.satClose, "h:m a");
        break;
      case "Sunday":
        timeOpen = moment(tradingDetails.sunOpen, "h:m a");
        timeClosed = moment(tradingDetails.sunClose, "h:m a");
        break;
      default:
        break;
    }

    timeOpen = timeOpen.isValid() ? timeOpen.format("HH:mm") : null;
    timeClosed = timeClosed.isValid() ? timeClosed.format("HH:mm") : null;

    if (date.format("MMM DD") == now.format("MMM DD")) {
      timeOpen = now.add(1, "hours").minutes(0).format("HH:mm");
    }

    earliestAvailableTime = timeOpen;

    renderTimePicker(timeOpen, timeClosed, earliestAvailableTime);
  });

  const showForm = () => {
    document.querySelector(".testDrive__form").classList.remove("fadedForm");
  };

  const getDisabledDays = (): string[] => {
    if (!tradingDetails) return [];
    let disabledDays: string[] = [];
    const isMobileTestDrive = mobileDestDriveField.value == "true";

    if (tradingDetails.monFriOpen?.toUpperCase() === "CLOSED") {
      disabledDays = disabledDays.concat([
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ]);
    }

    if (tradingDetails.satOpen?.toUpperCase() === "CLOSED" || isMobileTestDrive) {
      disabledDays.push("Saturday");
    }

    if (tradingDetails.sunOpen?.toUpperCase() === "CLOSED" || isMobileTestDrive) {
      disabledDays.push("Sunday");
    }

    return disabledDays;
  };

  const renderTimePicker = (
    timeOpen?,
    timeClosed?,
    earliestAvailableTime?
  ): void => {
    const timePicker = document.querySelector(".timepicker__wrap");
    const startTime = timeOpen || timePicker.getAttribute("startTime") || null;
    const endTime = timeClosed || timePicker.getAttribute("endTime") || null;
    const defaultTime = earliestAvailableTime
      ? moment(earliestAvailableTime, "h:m a")
      : moment("9:00AM", "h:m a");
    const defaultHour = defaultTime.hour();
    const defaultMinutes = defaultTime.minutes();
    const defaultMeridiem = defaultHour > 12 ? "PM" : "AM";
    
    if (timePicker) {
      ReactDOM.render(
        <TimePicker
          interval={30}
          startTime={startTime}
          endTime={endTime}
          defaultHour={defaultHour}
          defaultMinutes={defaultMinutes}
          defaultMeridiem={defaultMeridiem}
          externalFieldToStoreValue={document.getElementById("timepickerfield")}
          errorMessage={`Please choose a time between ${moment(
            startTime,
            "h:m a"
          ).format("hh:mmA")} to ${moment(endTime, "h:m a").format("hh:mmA")}`}
        />,
        timePicker
      );
    }
  };

  const renderDayPicker = (minDate?): void => {
    const datePicker = document.querySelector(".datepicker__wrap");
    if (datePicker) {
      // Tear down any previously mounted DayPicker properly before re-rendering.
      // The old `datePicker.innerHTML = ""` wiped React's DOM but left React's
      // internal root on the node, so the SECOND ReactDOM.render (e.g. after
      // choosing a different dealer without reloading) reconciled against
      // detached nodes and threw - leaving the datepicker blank. Unmounting
      // resets the container so the next render is a clean mount.
      ReactDOM.unmountComponentAtNode(datePicker);
      ReactDOM.render(
        <DayPicker
          externalFieldToStoreValue={document.getElementById("datepickerfield")}
          disabledDays={getDisabledDays()}
          minDate={minDate}
          fieldName="BookingDate"
          errorMessage="Invalid date"
        />,
        datePicker
      );

      const datepickerField = document.getElementById('datepickerfield') as HTMLInputElement;

      if (datepickerField) {
        datepickerField.placeholder = 'Preferred date';
      }
    }
  };

  const updateFormMessaging = (isMobileTestDrive: boolean) => {
    const formIntroText: any = document.querySelector(
      ".testDrive__formMessage"
    );
    const formNotice: any = document.querySelector(".testDrive__formNotice");
    const formSubmit: any = document.querySelector(
      ".testDrive__form .btn[type=submit]"
    );

    if (formIntroText) {
      formIntroText.textContent = `We will contact you to discuss and confirm your${
        isMobileTestDrive ? " mobile" : ""
      } test drive.`;
    }

    if (formNotice) {
      formNotice.innerHTML = isMobileTestDrive
        ? "<strong>Please note:</strong> your preferred date, time and location isn’t guaranteed. A Subaru representative will contact you to confirm your mobile booking request."
        : "<strong>Please note:</strong> your preferred date and time isn’t guaranteed. A Subaru representative will contact you to confirm your booking request.";
    }

    if (formSubmit) {
      formSubmit.value = isMobileTestDrive
        ? "Request mobile test drive"
        : "Request test drive";
    }
  };

  const mtdTerms: any = document.querySelector(".mtdTerms");
  each(document.querySelectorAll(".testDrive__driveType"), (el, index) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      mobileDestDriveField.value = index > 0 ? true : false;
      if (mtdTerms) {
        mtdTerms.style.display =
          mobileDestDriveField.value === "true" ? "block" : "none";
      }
      updateFormMessaging(mobileDestDriveField.value === "true");
      showForm();
    });
  });

  renderTimePicker();
  renderDayPicker();

  enforceTermsOnForm(document.querySelector("form.testDriveForm"));
  
  const formInputs = document.querySelectorAll('div.contourField input[type="text"]');
  const dateInput = document.querySelector("#datepickerfield") as HTMLInputElement;
  const TermsChk = document.querySelector('#terms[name="TocAgreement"]')  as HTMLInputElement | null;
  const recaptchaStatus = document.getElementById("recaptchaStatus") as HTMLInputElement;
  const tdBtn = document.querySelector("#testDriveSubmit");

  TermsChk.addEventListener('change', e => {
    const a = e.target as HTMLInputElement
    validateButton();
  });

  Array.from(formInputs).forEach((input) => {
    input.addEventListener('blur', (event) => {
     validateButton();
    });
  });

  window.addEventListener("dayPickerChanged", () => validateButton());

  (window as any).onRecaptchaVerified = (token: string): void => {
    //console.log("reCAPTCHA token:", token);
    if (token){
      //setReCaptchaVerified(true)
      recaptchaStatus.value = "verified";

    } else {
      recaptchaStatus.value = "";
    }
    validateButton();
  };

  const validateButton = () => {

    let fieldsCompleted = false;
    let fieldsValidated = false;
    let checkedTerms = false;

    //Run field checks
    let isAnyFieldBlank = false;
    let isAnyFieldInvalid = false;
    Array.from(formInputs).forEach((input) => {
      const inputElement = input as HTMLInputElement;
      if (!document.contains(inputElement)) return;
      if (inputElement.value.trim() === '') {
        isAnyFieldBlank = true;
      }

      if (inputElement.classList.contains("input-validation-error")){
        isAnyFieldInvalid = true;
      }
    });

    const currentDateInput = document.getElementById("datepickerfield") as HTMLInputElement;
    if (!currentDateInput || currentDateInput.value.trim() === '') {
      isAnyFieldBlank = true;
    }
    if (currentDateInput?.classList.contains("input-validation-error")){
      isAnyFieldInvalid = true;
    }

    if (!isAnyFieldBlank){
      fieldsCompleted = true;
    }
    
    if (!isAnyFieldInvalid){
      fieldsValidated = true;
    }
    //Check terms
    checkedTerms = TermsChk.checked

    if (checkedTerms && fieldsCompleted && fieldsValidated) {
      (tdBtn as HTMLInputElement).disabled = false;
      tdBtn.classList.remove('btn--disabled')
    }
    else {
      (tdBtn as HTMLInputElement).disabled = true;
      tdBtn.classList.add('btn--disabled')
    }
  }

};

TestDrive();
